import { render, staticRenderFns } from "./UpdateJobType.vue?vue&type=template&id=4d5a7977&scoped=true&"
import script from "./UpdateJobType.vue?vue&type=script&lang=js&"
export * from "./UpdateJobType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5a7977",
  null
  
)

export default component.exports